// 控制状态，
export const tableSataus = {
  data() {
    return {
      status: 0,
    };
  },
  computed: {
    isAdmin() {
      console.log('this.$store.state.user.user', this.$store.state.user)
      return this.$store.state.user.user.account === 'admin' || this.$store.state.user.user.account === 'sa'
    },
    isMileStoneOper() {
      return this.$store.state.user.roles.some(role => {
        return role === 'project:milestonerole'
      })
    },
    isProjectManager() { // 判断是否项目经理
      return this.$store.state.user.roles.some(role => {
        return role === '0003'
      })
    }
  },
  methods: {
    // 单据状态，
    statusName(status) {
      switch (status) {
        case 1:
          return "草稿";
        case 2:
          return "审批中";
        case 3:
          return "已审核";
        case 4:
          return "退回";
        case 5:
          return "反审核";
        case 9:
          return "关闭";
      }
    },
    planAchieveNormName(status) {
      switch (status) {
        case '0':
          return "未完成";
        case '1':
          return "单元测试";
        case '2':
          return "集成测试";
        case '3':
          return "系统测试";
      }
    },
    statusEdit(status) {
      // if (this.isAdmin) return false
      return ([1,4,5].includes(status))
    },
    statusAudit(status) {
      return status === 2
    },
    // 反审核操作
    statusUnAudit(status) {
      if (!this.isAdmin) return false
      return status === 3
    }
  }
};
